"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = exports.SCROLL_ID = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));

var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _values = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/values"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _qs = _interopRequireDefault(require("qs"));

var _config = _interopRequireDefault(require("../../../../targets/cord_sanofi/config.js"));

var _cssConstants = _interopRequireDefault(require("../../../../targets/cord_sanofi/cssConstants.js"));

var _reactFontawesome = _interopRequireDefault(require("react-fontawesome"));

var _CordovaFileHelper = _interopRequireDefault(require("../../../helpers/CordovaFileHelper"));

var _DrupalNugget = _interopRequireDefault(require("../../../../targets/cord_sanofi/DrupalNugget.js"));

var _KESI2BasicComponent = _interopRequireWildcard(require("../../../KESI2/KESI2BasicComponent"));

var _KESI2Helper = _interopRequireWildcard(require("../../../KESI2/KESI2Helper"));

var _Spinner = _interopRequireDefault(require("../Spinner/Spinner"));

var _DrupalLecture = _interopRequireDefault(require("./DrupalLecture.scss"));

var _VideoNugget = _interopRequireDefault(require("../../../KESI2/entities/nuggets/VideoNugget"));

var _VoteNugget = _interopRequireDefault(require("../../../KESI2/entities/nuggets/VoteNugget"));

var _QuizNugget = _interopRequireDefault(require("../../../KESI2/entities/nuggets/QuizNugget"));

var _TimeoutHelper = require("../../../helpers/TimeoutHelper");

var _DeviceInfoHelper = _interopRequireDefault(require("../../../helpers/DeviceInfoHelper"));

var _AppCordova = _interopRequireDefault(require("../../../../targets/cord_sanofi/AppCordova.js"));

var _index = require("../../../KESI2/Services/RemoteControlService/index");

var _NavigationManagerCordova = _interopRequireDefault(require("../../NavigationManagerCordova"));

var _Image = _interopRequireDefault(require("../Image/Image"));

var _MuiAlertHelper = require("../../../helpers/MuiAlertHelper");

var _DrupalLectureStrings = require("./DrupalLectureStrings");

var _ContentStore = _interopRequireDefault(require("../../../KESI2/Stores/ContentStore"));

var _DataStore = _interopRequireWildcard(require("../../../KESI2/Stores/DataStore2"));

var _SwipeNugget = _interopRequireDefault(require("../../../KESI2/entities/nuggets/SwipeNugget"));

var _Constants = require("../../constants/Constants");

var _FeedbackService = require("../../../KESI2/Services/FeedbackService");

var _ArrayHelper = require("../../../helpers/ArrayHelper");

var _ListNugget = _interopRequireDefault(require("../../../KESI2/entities/nuggets/ListNugget"));

var _GalleryNugget = _interopRequireDefault(require("../../../KESI2/entities/nuggets/GalleryNugget"));

var _CssHelper = _interopRequireDefault(require("../../../helpers/CssHelper"));

var _NullComponent = _interopRequireDefault(require("../NullComponent/NullComponent.js"));

var _reactZoomPanPinch = require("react-zoom-pan-pinch");

var _ScreenHelper = _interopRequireDefault(require("../../../helpers/ScreenHelper"));

var _TilesColorHelper = _interopRequireDefault(require("./TilesColorHelper"));

var _PreconditionChecker = require("../../../utils/PreconditionChecker");

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var SCROLL_ID = 'lecture_scroll_frame';
exports.SCROLL_ID = SCROLL_ID;
var MAIN_RUBRIC = 'mainrubric';

var DrupalLecture = /*#__PURE__*/function (_Kesi2BasicComponent) {
  (0, _inherits2["default"])(DrupalLecture, _Kesi2BasicComponent);

  var _super = _createSuper(DrupalLecture);

  function DrupalLecture(props, context) {
    var _thisSuper, _this;

    (0, _classCallCheck2["default"])(this, DrupalLecture);
    _this = _super.call(this, props, context, props.params.contentId);
    /*
    KESI2BasicComponent also defines state, in order to keep DrupalLecture state
    and the already initialized Kesi2BasicComponent state we use ...this.state here.
    If we dont do that keys like "course" will be overridden to be null resulting in an app crash.
     */

    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "focusFirstNugget", function () {
      if (_config["default"].availableForScreenReader) {
        var lectureEl = document.getElementById('nuggetContainer');

        if (lectureEl) {
          var child = lectureEl.firstChild;
          if (child) child.focus();
        }
      }
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "update", function () {
      _this.forceUpdate();
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "checkHeight", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      var setHeight;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setHeight = /*#__PURE__*/function () {
                var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
                  var count,
                      el2,
                      _args = arguments;
                  return _regenerator["default"].wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          count = _args.length > 0 && _args[0] !== undefined ? _args[0] : 20;
                          el2 = document.getElementById(SCROLL_ID);
                          console.log('checkWidth', el2);

                          if (!(count <= 0)) {
                            _context.next = 5;
                            break;
                          }

                          return _context.abrupt("return");

                        case 5:
                          if (el2) {
                            _context.next = 12;
                            break;
                          }

                          console.log('no el2 -> wait ', count);
                          _context.next = 9;
                          return (0, _TimeoutHelper.timeout)(200);

                        case 9:
                          setHeight(count - 1);
                          _context.next = 14;
                          break;

                        case 12:
                          console.log('resetting height of inner div to enable scrolling in safari');
                          el2.style.height = 'calc(100% + 1px)';

                        case 14:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function setHeight() {
                  return _ref2.apply(this, arguments);
                };
              }();

              if (!_DeviceInfoHelper["default"].isSafari()) {
                _context2.next = 5;
                break;
              }

              _context2.next = 4;
              return (0, _TimeoutHelper.timeout)(1000);

            case 4:
              setHeight();

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "checkIosHeight", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
      var setHeight;
      return _regenerator["default"].wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              setHeight = /*#__PURE__*/function () {
                var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
                  var count,
                      el2,
                      _args3 = arguments;
                  return _regenerator["default"].wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          count = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : 20;
                          el2 = document.getElementById(SCROLL_ID);
                          console.log('checkIosHeight', el2);

                          if (!(count <= 0)) {
                            _context3.next = 5;
                            break;
                          }

                          return _context3.abrupt("return");

                        case 5:
                          if (el2) {
                            _context3.next = 12;
                            break;
                          }

                          console.log('checkIosHeight no el2 -> wait ', count);
                          _context3.next = 9;
                          return (0, _TimeoutHelper.timeout)(200);

                        case 9:
                          setHeight(count - 1);
                          _context3.next = 16;
                          break;

                        case 12:
                          el2.style.height = '50px';
                          _context3.next = 15;
                          return (0, _TimeoutHelper.timeout)(100);

                        case 15:
                          el2.style.height = '100%';

                        case 16:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3);
                }));

                return function setHeight() {
                  return _ref4.apply(this, arguments);
                };
              }();

              if (_DeviceInfoHelper["default"].isiOS()) {
                setHeight();
              }

            case 2:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    })));
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "receiveMessage", function (event) {
      // console.log('scrolling down message')
      // const el = document.getElementById(SCROLL_ID)
      // if (el) {
      //   el.scrollTop = el.scrollTop + event.data
      // }
      if (event.data === 'scrolling down' && event.origin === 'http://messknecht.equeo.de') {
        var el = document.getElementById(SCROLL_ID);

        if (el) {
          el.scrollTop = el.scrollTop + _Constants.IFRAME_WHEEL_SCROLL_HEIGHT;
        }
      } else if (event.data === 'scrolling up' && event.origin === 'http://messknecht.equeo.de') {
        var _el = document.getElementById(SCROLL_ID);

        if (_el) {
          _el.scrollTop = _el.scrollTop - _Constants.IFRAME_WHEEL_SCROLL_HEIGHT;
        }
      }
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "innerForceUpdate", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5() {
      return _regenerator["default"].wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              console.log('DrupalLecture innerForceUpdate');
              _context5.next = 3;
              return (0, _TimeoutHelper.timeout)(500);

            case 3:
              _this.forceUpdate();

              _this.checkIosHeight();

            case 5:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    })));
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "onScroll", /*#__PURE__*/function () {
      var _ref6 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(evt) {
        var lecture, scrollFrame, scrollTop, nuggetsToMark, i;
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (!(_config["default"].markOpenedLecturesAsCompletelyRead && !evt)) {
                  _context7.next = 2;
                  break;
                }

                return _context7.abrupt("return");

              case 2:
                lecture = _this.state.content[_this.props.params.contentId];
                scrollFrame = document.getElementsByClassName("".concat(lecture.theme, " frame"))[0];

                if (scrollFrame) {
                  _context7.next = 6;
                  break;
                }

                return _context7.abrupt("return");

              case 6:
                scrollTop = scrollFrame.scrollTop || 0;

                _NavigationManagerCordova["default"].setScrollTop(Math.max(0, scrollTop / (scrollFrame.scrollHeight - scrollFrame.offsetHeight)));

                if (!(scrollTop + scrollFrame.offsetHeight + 100 > scrollFrame.scrollHeight)) {
                  _context7.next = 18;
                  break;
                }

                // mark all nuggets as read because we are at the bottom of the page
                nuggetsToMark = [];
                (0, _values["default"])(_this.state.nuggets).forEach( /*#__PURE__*/function () {
                  var _ref7 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(nugget) {
                    return _regenerator["default"].wrap(function _callee6$(_context6) {
                      while (1) {
                        switch (_context6.prev = _context6.next) {
                          case 0:
                            if (nugget.notMandatory || _KESI2BasicComponent.READ_ON_SCROLL_NUGGETS.indexOf(nugget.type) >= 0) {
                              nuggetsToMark.push(nugget);
                            }

                          case 1:
                          case "end":
                            return _context6.stop();
                        }
                      }
                    }, _callee6);
                  }));

                  return function (_x2) {
                    return _ref7.apply(this, arguments);
                  };
                }());
                i = 0;

              case 12:
                if (!(i < nuggetsToMark.length)) {
                  _context7.next = 18;
                  break;
                }

                _context7.next = 15;
                return _this.markNuggetAsRead(nuggetsToMark[i].id);

              case 15:
                i++;
                _context7.next = 12;
                break;

              case 18:
                if ((0, _KESI2Helper.isRemoteControllingEnabled)()) {
                  clearTimeout(_this.onScrollDeferredTimer);
                  _this.onScrollDeferredTimer = setTimeout(function () {
                    _this.onScrollDeferred(scrollFrame, scrollTop);
                  }, 200);
                }

              case 19:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      return function (_x) {
        return _ref6.apply(this, arguments);
      };
    }());
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "onScrollDeferred", function (scrollFrame, position) {
      if ((0, _KESI2Helper.isRemoteControllingEnabled)()) {
        var nuggetsSorted = (0, _values["default"])(_this.state.nuggets).sort(function (a, b) {
          if (a.offsetTop > b.offsetTop) {
            return 1;
          }

          if (a.offsetTop === b.offsetTop) {
            return 0;
          }

          return -1;
        });

        if (nuggetsSorted) {
          var nuggetInView = null;
          nuggetsSorted.find(function (nugget) {
            if (nuggetInView && nugget.offsetTop >= position) {
              return true;
            }

            nuggetInView = nugget;
          });

          var path = _NavigationManagerCordova["default"].getCurrentPath();

          (0, _index.pushNavigateMessage)(_this.props.params.contentId, path, Math.max(0, position / (scrollFrame.scrollHeight - scrollFrame.offsetHeight)));
        }
      }
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "registerNugget", function (id, type, className) {
      var isInNuggetContainer = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var offsetTop = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

      if (!_this.state.nuggets[id]) {
        var isRead = _KESI2Helper["default"].checkIfContentIsMarkedAsReadInStore(null, id); // the content may not be available to this.state.content yet


        var nuggetObject = _ContentStore["default"].state.content[id];
        _this.state.nuggets[id] = {
          id: id,
          type: type,
          className: className,
          read: isRead,
          isInNuggetContainer: isInNuggetContainer,
          offsetTop: null,
          notMandatory: nuggetObject ? nuggetObject.notMandatory : false
        };
      }

      if (offsetTop !== null && offsetTop >= 0) {
        _this.state.nuggets[id].offsetTop = offsetTop;
      }
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "markEveryNuggetAsSeen", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8() {
      return _regenerator["default"].wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              console.log('this.state.nuggets', (0, _values["default"])(_this.state.nuggets));

              _KESI2Helper["default"].setContentsAsSeen((0, _values["default"])(_this.state.nuggets));

            case 2:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    })));
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "markNuggetAsFavorite", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9() {
      var additionalData, isFavourite, fav;
      return _regenerator["default"].wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              additionalData = _this.state.data[_DataStore.DATA_STORE_PATHS.KESI_ADDITIONAL_DATA][_this.props.params.contentId];
              isFavourite = additionalData ? additionalData.favorite : false;
              fav = !isFavourite;
              _context9.next = 5;
              return _KESI2Helper["default"].setFavoriteForLectureId(_this.props.params.contentId, fav);

            case 5:
              _this.forceUpdate();

            case 6:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    })));
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "markNuggetAsRead", /*#__PURE__*/function () {
      var _ref10 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee10(id) {
        var readNugget;
        return _regenerator["default"].wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                readNugget = _this.state.nuggets[id];

                if (!(!readNugget.read && !readNugget.isInSwipeNugget)) {
                  _context10.next = 6;
                  break;
                }

                _context10.next = 4;
                return _KESI2Helper["default"].setReadForId(id, true);

              case 4:
                readNugget.read = true;

                _this.checkIfRead();

              case 6:
                return _context10.abrupt("return", _promise["default"].resolve());

              case 7:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }));

      return function (_x3) {
        return _ref10.apply(this, arguments);
      };
    }());
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "scrollToNugget", function (nugget) {
      if (!nugget) {
        console.warn("can't scroll to nugget because nugget is undefined");
        return;
      }

      if (nugget.offsetTop === null) {
        console.warn("can't scroll to nugget with id ".concat(nugget.id, " because no offsetTop is given in nugget"));
        return;
      }

      var pos = nugget.offsetTop;

      if (nugget.isInSwipeNugget) {
        var swipeNugget = (0, _values["default"])(_this.state.nuggets).find(function (nugget) {
          return nugget.type === _SwipeNugget["default"].CLASS;
        });

        if (swipeNugget) {
          pos += swipeNugget.offsetTop;
        }
      }

      var scrollFrame = document.getElementById(SCROLL_ID); // updating the value twice makes sure the screen is not blank if scrolled too far

      scrollFrame.scrollTop = pos - 24;
      setTimeout(function () {
        scrollFrame.scrollTop = pos - 25;
      });
      setTimeout(function () {
        scrollFrame.scrollTop = pos - 26;
      }, 10);
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "scrollToNuggetWithId", function (nuggetId) {
      var nugget = _this.state.nuggets[nuggetId];

      _this.scrollToNugget(nugget);
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "scrollToPercentualPosition", function (scrollPosPercent) {
      var scrollFrame = document.getElementById(SCROLL_ID);
      var pos = scrollPosPercent * (scrollFrame.scrollHeight - scrollFrame.offsetHeight); // updating the value twice makes sure the screen is not blank if scrolled too far

      scrollFrame.scrollTop = pos - 1;
      setTimeout(function () {
        scrollFrame.scrollTop = pos;
      });
      setTimeout(function () {
        scrollFrame.scrollTop = pos + 1;
      }, 10);
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "scrollToTop", function () {
      var lecture = _this.state.content[_this.props.params.contentId];
      var scrollFrame = document.getElementById(SCROLL_ID); // updating the value twice makes sure the screen is not blank if scrolled too far

      scrollFrame.scrollTop = 0;
      setTimeout(function () {
        scrollFrame.scrollTop = 1;
      });
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "scrollToFirstUnread", function () {
      var lecture = _this.state.content[_this.props.params.contentId];
      var nuggetIds = lecture.nuggetIds;
      var firstUnread = nuggetIds.find(function (contentId) {
        var read = _KESI2Helper["default"].checkIfContentIsMarkedAsReadInStore(null, contentId);

        return read !== true;
      });

      _this.scrollToNuggetWithId(firstUnread);
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "getQdActionsIfAny", function () {
      var match = window.location.href.split('?');
      if (match.length < 2) return;

      var parsed = _qs["default"].parse(match[1]);

      if (!parsed.nugget || !parsed.action) return;
      var doesExist = (0, _keys["default"])(_this.state.nuggets).some(function (key) {
        return key === parsed.nugget;
      });
      if (!doesExist) return;
      var actions = (0, _assign["default"])({}, _this.state.qdActions);
      actions[parsed.nugget] = parsed.action;

      _this.setState({
        qdActions: actions
      });

      _this.scrollToNuggetWithId(parsed.nugget);
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "setFullscreenContent", function (fullscreen) {
      if (_this.state.fullscreenContent !== fullscreen) {
        _this.setState({
          fullscreenContent: fullscreen
        });
      }
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "setLike", function () {
      console.log('setLike');
      var likes = JSON.parse((0, _stringify["default"])(_DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_LIKES) || []));
      var id = _this.props.params.contentId;
      var likeIndex = likes.indexOf(id);

      if (likeIndex < 0) {
        likes.push(id);
        (0, _FeedbackService.pushLikeMessage)(id, 'add', _config["default"].rootId);
      } else {
        (0, _ArrayHelper.removeElementAtPosition)(likes, likeIndex);
        (0, _FeedbackService.pushLikeMessage)(id, 'remove', _config["default"].rootId);
      }

      _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.KESI_LIKES, likes);
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "setScale", function (values) {
      if (values && values.scale) {
        if (values.scale > 1 && _this.state.scrollingEnabled) {
          _this.setState({
            scrollingEnabled: false
          });
        } else if (values.scale === 1 && !_this.state.scrollingEnabled) {
          _this.setState({
            scrollingEnabled: true
          });
        }
      }
    });
    _this.state = _objectSpread({
      course: null,
      filePath: _DeviceInfoHelper["default"].isBrowser() ? null : _CordovaFileHelper["default"].getDataFolder(),
      allRead: false,
      qdActions: {},
      fullscreenContent: false,
      scrollingEnabled: true
    }, _this.state);
    _this.currentUpdateValue = props.updateValue;
    _this.filePath = '';
    _this.state.nuggets = {};
    _this.alertShown = false;
    (0, _get2["default"])((_thisSuper = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(DrupalLecture.prototype)), "setDataStorePaths", _thisSuper).call(_thisSuper, [_DataStore.DATA_STORE_PATHS.KESI_ADDITIONAL_DATA, _DataStore.DATA_STORE_PATHS.KESI_ALL_LIKES, _DataStore.DATA_STORE_PATHS.KESI_LIKES, _DataStore.DATA_STORE_PATHS.ERGO_POTENTIAL_RESULT, _DataStore.DATA_STORE_PATHS.KESI_UPDATE_VALUE]);
    return _this;
  }

  (0, _createClass2["default"])(DrupalLecture, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(DrupalLecture.prototype), "componentDidUpdate", this).call(this, prevProps, prevState, snapshot);

      if (prevProps.params.contentId !== this.props.params.contentId || this.props.updateValue !== this.currentUpdateValue) {
        this.currentUpdateValue = this.props.updateValue;
      } // if (prevState.data[DATA_STORE_PATHS.KESI_UPDATE_VALUE] !== this.state.data[DATA_STORE_PATHS.KESI_UPDATE_VALUE]) {
      //   console.log('TIMER update value different in drupal lecture')
      //   this.forceUpdate()
      // }

    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!_DeviceInfoHelper["default"].isBrowser()) {
        window.screen.orientation.addEventListener('change', this.innerForceUpdate);
      }

      if (this.props.setShowFavButton) {
        this.props.setShowFavButton(false);
      }

      _NavigationManagerCordova["default"].setScrollTop(0);

      _AppCordova["default"].addRemoteScrollListener(this.props.params.contentId, this.scrollToPercentualPosition);

      this.onScroll();
      this.checkIfRead();
      this.getQdActionsIfAny(); // const isLocked = this.checkIfContentLocked()
      //
      // if (isLocked) {
      //   NavigationManagerCordova.goHome()
      // }
      // else {

      window.addEventListener('hashchange', this.getQdActionsIfAny);

      if (_DeviceInfoHelper["default"].isBrowser()) {
        _ScreenHelper["default"].instance().addOnWindowSizeChangedListener(this.update);
      }

      if (_DeviceInfoHelper["default"].isBrowser()) {
        window.addEventListener('message', this.receiveMessage, false);
      }

      if (_config["default"].useTileBackgroundColorInTile || _config["default"].openTilesInFullScreen) {
        var lecture = _KESI2Helper["default"].getContentById(this.props.params.contentId);

        var colorToSet = lecture.innerBackgroundColor ? lecture.innerBackgroundColor : lecture.backgroundColor;

        _NavigationManagerCordova["default"].setNavbarBackgroundColor(colorToSet);
      }

      this.checkHeight();
      this.markEveryNuggetAsSeen();
      this.focusFirstNugget(); // }
    } // checkIfContentLocked = () => {
    //   const lecture = KESI2Helper.getContentById(this.props.params.contentId)
    //   if (lecture.openPrecondition) {
    //     const failingPrecondition = getFailingPrecondition(lecture.openPrecondition)
    //     return !!failingPrecondition
    //   }
    // }

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(DrupalLecture.prototype), "componentWillUnmount", this).call(this);
      var el2 = document.getElementById(SCROLL_ID);

      if (el2) {
        el2.style.height = '100%';
      }

      if (_DeviceInfoHelper["default"].isBrowser()) {
        _ScreenHelper["default"].instance().removeOnWindowSizeChangedListener(this.update);
      }

      window.removeEventListener('hashchange', this.getQdActionsIfAny);

      _AppCordova["default"].removeRemoteScrollListener(this.props.params.contentId);

      if (!_DeviceInfoHelper["default"].isBrowser()) {
        window.screen.orientation.removeEventListener('change', this.innerForceUpdate);
      }
    }
  }, {
    key: "checkIfRead",
    value: function () {
      var _checkIfRead = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee11() {
        var readEverything, read, increaseReadLectureCountForSnoo, allDone, okButton, _okButton, buttons, certPathArray, certPath, navigateButton;

        return _regenerator["default"].wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                readEverything = (0, _values["default"])(this.state.nuggets).every(function (nugget) {
                  return nugget.read || nugget.isInNuggetContainer || nugget.notMandatory || nugget.type === _GalleryNugget["default"].CLASS;
                });

                if (!(readEverything || _config["default"].markOpenedLecturesAsCompletelyRead)) {
                  _context11.next = 19;
                  break;
                }

                read = true;
                increaseReadLectureCountForSnoo = _config["default"].isSnooApp && read && _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.SNOO_UPPEST_LECTURE_ID) === this.props.params.contentId;

                if (!increaseReadLectureCountForSnoo) {
                  _context11.next = 11;
                  break;
                }

                _context11.next = 7;
                return (0, _TimeoutHelper.timeout)(500);

              case 7:
                _context11.next = 9;
                return _KESI2Helper["default"].setReadForId(this.props.params.contentId, read, true, increaseReadLectureCountForSnoo);

              case 9:
                _context11.next = 13;
                break;

              case 11:
                _context11.next = 13;
                return _KESI2Helper["default"].setReadForId(this.props.params.contentId, read, true);

              case 13:
                this.setState({
                  allRead: true
                });
                this.forceUpdate();
                _context11.next = 17;
                return _KESI2Helper["default"].checkIfSendingCertificate(this.state);

              case 17:
                allDone = _context11.sent;

                if (allDone && (_config["default"].sendCertificate || _config["default"].sendCertificateOnUserRequest)) {
                  if (_config["default"].useSnomLinkId) {
                    if (!this.alertShown) {
                      okButton = {
                        label: (0, _DrupalLectureStrings.getString)('OK'),
                        callback: function callback() {
                          var url = decodeURIComponent(_DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.SNOM_REDIRECT_URL));
                          window.open(url, url.startsWith('https') ? '_self' : '_blank'); // can't open insecure pages on same page
                        }
                      };
                      this.alertShown = true;
                      (0, _MuiAlertHelper.showWideAlertHtml)((0, _DrupalLectureStrings.getString)("<div>".concat((0, _DrupalLectureStrings.getString)('FINISHED_TEXT'), "<br />").concat((0, _DrupalLectureStrings.getString)('FINISHED_TEXT2', [decodeURIComponent(_DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.SNOM_REDIRECT_URL))]), "</div>")), (0, _DrupalLectureStrings.getString)('ALL_DONE_TITLE'), false, [okButton]);
                    }
                  } else if (_config["default"].sendCertificateOnUserRequest) {
                    _okButton = {
                      label: (0, _DrupalLectureStrings.getString)('OK'),
                      callback: function callback() {}
                    };
                    buttons = [_okButton];
                    certPathArray = _KESI2Helper["default"].getCertificatePath();
                    certPath = certPathArray.join('!');
                    console.log('certpath', certPathArray, certPath);

                    if (certPath) {
                      navigateButton = {
                        label: (0, _DrupalLectureStrings.getString)('TO_CERTIFICATE'),
                        callback: function callback() {
                          _NavigationManagerCordova["default"].goTo("".concat(_config["default"].baseRoute, "/").concat(certPath));
                        }
                      };
                      buttons.push(navigateButton);
                    }

                    (0, _MuiAlertHelper.showWideAlertHtml)((0, _DrupalLectureStrings.getString)('ALL_DONE_TEXT'), (0, _DrupalLectureStrings.getString)('ALL_DONE_TITLE'), true, buttons);
                  } else {
                    if (_config["default"].showAllDoneDialog) {
                      (0, _MuiAlertHelper.showWideAlertHtml)((0, _DrupalLectureStrings.getString)('ALL_DONE_TEXT'), (0, _DrupalLectureStrings.getString)('ALL_DONE_TITLE'));
                    }
                  }
                }

              case 19:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function checkIfRead() {
        return _checkIfRead.apply(this, arguments);
      }

      return checkIfRead;
    }()
  }, {
    key: "getStyles",
    value: function getStyles() {
      if (this.props.doNotSetHeight) {
        return {};
      }

      return {
        swipeContainer: {
          height: '100%'
        }
      };
    } // async loadCourse(id) {
    //   if (id === null) {
    //     console.warn('loadCourse called in Chapter but no id given');
    //     return Promise.reject();
    //   }
    //   try {
    //     const course = await CourseLoader.getCourse(id);
    //     this.setState({course});
    //     this.props.setTitle(course.title);
    //     return Promise.resolve();
    //   }
    //   catch (error) {
    //     console.log('course not available, going to home page');
    //     NavigationManager.goHome();
    //     return Promise.resolve();  // really meant resolve here
    //   }
    //
    // }

  }, {
    key: "renderHeader",
    value: function renderHeader() {
      var _this2 = this;

      var lecture = this.state.content[this.props.params.contentId];
      var videoNugget = (0, _values["default"])(this.state.nuggets).find(function (nugget) {
        return nugget.type === _VideoNugget["default"].CLASS;
      });
      var voteNugget = (0, _values["default"])(this.state.nuggets).find(function (nugget) {
        return nugget.type === _VoteNugget["default"].CLASS;
      });
      var quizNugget = (0, _values["default"])(this.state.nuggets).find(function (nugget) {
        return nugget.type === _QuizNugget["default"].CLASS;
      });
      var jumpToVideo = Boolean(videoNugget);
      var jumpToVote = Boolean(voteNugget);
      var jumpToQuiz = Boolean(quizNugget);
      var headerIconPath = _DeviceInfoHelper["default"].isBrowser() ? lecture.icon : "".concat(this.state.filePath).concat(lecture.icon);
      var classNames = "".concat(_config["default"].openTilesInFullScreen ? _DrupalLecture["default"].headerContainerFullScreen : _DrupalLecture["default"].headerContainer, " ").concat(this.props.colorClasses ? this.props.colorClasses.backgroundClass : null, " ctnLectureHeader");
      var additionalData = this.state.data[_DataStore.DATA_STORE_PATHS.KESI_ADDITIONAL_DATA] ? this.state.data[_DataStore.DATA_STORE_PATHS.KESI_ADDITIONAL_DATA][this.props.params.contentId] : null;
      var isFavorite = additionalData ? additionalData.favorite : false;
      var isRead = _KESI2Helper["default"].checkIfContentIsMarkedAsReadInStore(null, this.props.params.contentId) || false;
      var bannerImage = lecture.bannerImage ? _DeviceInfoHelper["default"].isBrowser() ? lecture.bannerImage : "".concat(this.state.filePath).concat(lecture.bannerImage) : null;

      var textColor = _TilesColorHelper["default"].getMatchingLectureHeaderTextColorToBackgroundColor(this.props.innerBackgroundColor);

      return /*#__PURE__*/_react["default"].createElement("div", {
        id: 'headerContainer',
        className: classNames,
        style: _cssConstants["default"].colors.lectureHeaderBackground ? {
          background: _cssConstants["default"].colors.lectureHeaderBackground
        } : {
          background: this.props.innerBackgroundColor
        }
      }, bannerImage ? /*#__PURE__*/_react["default"].createElement(_Image["default"], {
        alt: 'Banner Bild',
        style: {
          position: 'absolute',
          zIndex: 1,
          width: '100%',
          height: '100%'
        },
        src: bannerImage
      }) : null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalLecture["default"].titleContainer,
        style: {
          color: textColor
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(_config["default"].centerLectureTitle ? _DrupalLecture["default"].innerTitleContainerCentered : _DrupalLecture["default"].innerTitleContainer, " ").concat(_config["default"].showLectureHeaderIcon ? '' : _DrupalLecture["default"].fullWidth)
      }, _config["default"].showDayInfoOnTile ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalLecture["default"].headerDay
      }, this.props.currentDayStr) : null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalLecture["default"].headerTitle,
        style: {
          fontFamily: _cssConstants["default"].headerFontFamily ? _cssConstants["default"].headerFontFamily : _cssConstants["default"].fontFamily
        }
      }, lecture.itemid ? (0, _DrupalLectureStrings.getString)("".concat(lecture.itemid, "_title")) || lecture.title : lecture.title), _config["default"].showSubtitleOnHeader ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalLecture["default"].headerSubtitle
      }, lecture.itemid ? (0, _DrupalLectureStrings.getString)("".concat(lecture.itemid, "_subtitle")) || lecture.subtitle : lecture.subtitle) : null), lecture.icon && _config["default"].showLectureHeaderIcon && /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(_DrupalLecture["default"].headerIcon, " icon"),
        style: {
          color: textColor
        }
      }, /*#__PURE__*/_react["default"].createElement(_Image["default"], {
        src: headerIconPath,
        alt: "lecture header icon"
      }))), _config["default"].showHeaderInfos ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalLecture["default"].jumpButtons,
        style: {
          color: textColor
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalLecture["default"].leftJumpButtons
      }, lecture.processTime && lecture.processTime > 0 ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalLecture["default"].time
      }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
        name: "clock-o"
      }), /*#__PURE__*/_react["default"].createElement("b", null, "\xA0", lecture.processTime, "\u2019")) : null, _config["default"].showJumpButtons && jumpToVideo && /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalLecture["default"].singleJumpButton,
        onClick: function onClick() {
          _this2.scrollToNugget(videoNugget);
        }
      }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
        name: "angle-down"
      }), "\xA0", (0, _DrupalLectureStrings.getString)('TO_VIDEO')), _config["default"].showJumpButtons && jumpToVote && /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalLecture["default"].singleJumpButton,
        onClick: function onClick() {
          _this2.scrollToNugget(voteNugget);
        }
      }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
        name: "angle-down"
      }), "\xA0", (0, _DrupalLectureStrings.getString)('TO_VOTING')), _config["default"].showJumpButtons && jumpToQuiz && /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalLecture["default"].singleJumpButton,
        onClick: function onClick() {
          _this2.scrollToNugget(quizNugget);
        }
      }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
        name: "angle-down"
      }), "\xA0", (0, _DrupalLectureStrings.getString)('TO_QUIZ'))), /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalLecture["default"].rightJumpButtons
      }, _config["default"].showFav ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalLecture["default"].favIcon
      }, isFavorite ? /*#__PURE__*/_react["default"].createElement("div", {
        onClick: function onClick() {
          _this2.markNuggetAsFavorite();
        }
      }, /*#__PURE__*/_react["default"].createElement("img", {
        alt: 'Lesezeichen aktiv',
        src: _config["default"].bookmarkIconTrueLectureHeader
      }), "\xA0Favorit") : /*#__PURE__*/_react["default"].createElement("div", {
        onClick: function onClick() {
          _this2.markNuggetAsFavorite();
        }
      }, /*#__PURE__*/_react["default"].createElement("img", {
        alt: 'Lesezeichen nicht aktiv',
        src: _config["default"].bookmarkIconFalseLectureHeader
      }), "\xA0Favorit")) : null, _config["default"].showRead ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalLecture["default"].readIcon
      }, isRead ? /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
        alt: '"Lektion gelesen" Icon',
        role: 'button',
        name: "check-circle"
      }) : /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
        alt: '"Lektion nicht gelesen" Icon',
        role: 'button',
        name: "circle-o"
      })) : null)) : null);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      if (this.state.filePath === null && !_DeviceInfoHelper["default"].isBrowser()) {
        return /*#__PURE__*/_react["default"].createElement(_Spinner["default"], null);
      } else {
        // if there are rubrics, this element can be a spoc or lecture
        var lectureOrSpoc = this.state.content[this.props.params.contentId];

        if ((lectureOrSpoc === null || lectureOrSpoc === void 0 ? void 0 : lectureOrSpoc.rubrics) && (lectureOrSpoc === null || lectureOrSpoc === void 0 ? void 0 : lectureOrSpoc.rubrics.length) > 0) {
          return /*#__PURE__*/_react["default"].createElement(_NullComponent["default"], {
            rubrics: lectureOrSpoc.rubrics,
            contentPathArray: this.props.contentPathArray,
            isMainCatalogue: lectureOrSpoc.keyword === MAIN_RUBRIC
          });
        } // now, it certainly is a lecture


        var lecture = lectureOrSpoc;
        var nuggetIds = lecture.nuggetIds;
        var likes = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_LIKES) || [];
        var likeIndex = likes.indexOf(this.props.params.contentId);

        var allLikes = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_ALL_LIKES);

        var currentLikesForId = allLikes && allLikes["".concat(this.props.params.contentId)] ? allLikes["".concat(this.props.params.contentId)] : 0;
        var style = {};

        if (this.props.showContent || !_config["default"].noFlippingTiles) {
          style.opacity = 1;

          if (_config["default"].useTileBackgroundColorInTile) {
            _CssHelper["default"].addCssRule('h1', "{color: ".concat(lecture.backgroundColor, "}"));

            _CssHelper["default"].addCssRule('h2', "{color: ".concat(lecture.backgroundColor, "}"));

            _CssHelper["default"].addCssRule('.title', "{color: ".concat(lecture.backgroundColor, " !important}"));
          }
        } else {
          style.opacity = 0;
        }

        var showExtraMenu = _config["default"].showSpocsInExtraMenu;
        var extraClassName = '';

        if (showExtraMenu) {
          extraClassName += " ".concat(_DrupalLecture["default"].extraPadding);
        }

        if (_DeviceInfoHelper["default"].isMobileiOSBrowser()) {
          extraClassName += " ".concat(_DrupalLecture["default"].extraPaddingMobileBrowser);
        }

        var outerContent = /*#__PURE__*/_react["default"].createElement("div", {
          className: "".concat(lecture.theme, " frame frameNew ").concat(_DrupalLecture["default"].lectureFrame).concat(extraClassName),
          id: SCROLL_ID,
          onScroll: this.onScroll,
          style: style
        }, /*#__PURE__*/_react["default"].createElement("div", {
          id: 'nuggetContainer',
          className: _DeviceInfoHelper["default"].isBrowser() ? _DrupalLecture["default"].innerFrame : _DrupalLecture["default"].innerFrameMobile
        }, _config["default"].showLectureHeader && !this.state.fullscreenContent ? /*#__PURE__*/_react["default"].createElement("div", {
          className: _DrupalLecture["default"].header
        }, this.renderHeader()) : null, (!nuggetIds || nuggetIds.length === 0) && /*#__PURE__*/_react["default"].createElement("div", null, "Kein Content vorhanden"), nuggetIds && nuggetIds.length > 0 && nuggetIds.map(function (nuggetId) {
          var content = _KESI2Helper["default"].getContentById(nuggetId);

          if (!content) {
            return null;
          }

          var forcedUIColor = null;

          if (_config["default"].useTileBackgroundColorInTile && lecture.backgroundColor) {
            forcedUIColor = lecture.backgroundColor;
          }

          return /*#__PURE__*/_react["default"].createElement(_DrupalNugget["default"], {
            key: nuggetId,
            id: nuggetId,
            action: _this3.state.qdActions[nuggetId],
            path: _this3.state.filePath,
            registerNugget: _this3.registerNugget,
            markAsRead: _this3.markNuggetAsRead,
            contentPathArray: _this3.props.contentPathArray,
            flexLink: lecture.flexLink,
            regionCode: _this3.props.regionCode,
            setBackButtonFunc: _this3.props.setBackButtonFunc,
            closeTile: _this3.props.closeTile,
            setTitle: _this3.props.setTitle,
            expanded: _this3.props.expanded,
            scrollToNugget: _this3.scrollToNuggetWithId,
            setFullscreenContent: _this3.setFullscreenContent,
            scrollFrameId: _this3.props.scrollFrameId,
            forcedUIColor: forcedUIColor,
            goHomeFn: _this3.props.goHomeFn,
            lectureBackgroundColor: _this3.props.innerBackgroundColor,
            setWizardArrowFns: _this3.props.setWizardArrowFns,
            resetScrollIndicatorFn: _this3.props.resetScrollIndicatorFn,
            closePrevDialogFn: _this3.props.goUpFunc,
            backgroundColor: _this3.props.backgroundColor
          });
        }), _config["default"].hasLikeFunctionalityForLectures && !lecture.hideLikeFeature ? /*#__PURE__*/_react["default"].createElement("div", {
          className: _DrupalLecture["default"].likeContainer
        }, _config["default"].useTargetIcons ? /*#__PURE__*/_react["default"].createElement("img", {
          alt: 'Likebutton',
          className: _DrupalLecture["default"].svgLikeButton,
          onClick: function onClick() {
            return _this3.setLike();
          },
          src: likeIndex < 0 ? _config["default"].likeInactive : _config["default"].likeActive
        }) : /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
          alt: 'Likebutton',
          onClick: function onClick() {
            return _this3.setLike();
          },
          className: likeIndex < 0 ? _DrupalLecture["default"].likeButton : _DrupalLecture["default"].likeButtonActivated,
          name: 'thumbs-o-up'
        }), /*#__PURE__*/_react["default"].createElement("div", {
          className: _DrupalLecture["default"].likeText
        }, "".concat(currentLikesForId, " ").concat(currentLikesForId === 1 ? 'Like' : 'Likes'))) : null, _config["default"].showUpArrow && lecture.hideContinueArrow !== true ? /*#__PURE__*/_react["default"].createElement("div", {
          className: _DrupalLecture["default"].jumpToTop,
          style: this.state.allRead || _config["default"].showUpArrowAlwaysAsRead ? {
            backgroundColor: lecture.backgroundColor ? lecture.backgroundColor : _cssConstants["default"].colors.lectureBackButton ? _cssConstants["default"].colors.lectureBackButton : 'green'
          } : {},
          onClick: this.state.allRead || _config["default"].showUpArrowAlwaysAsRead ? this.props.goUpFunc : this.scrollToFirstUnread
        }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
          name: "angle-up",
          className: _DrupalLecture["default"].jumpToTopIcon,
          style: this.state.allRead || _config["default"].showUpArrowAlwaysAsRead ? {
            transform: 'translate3d(-35%,-50%,0) rotate3d(0, 0, 1, 90deg)'
          } : {}
        }), _config["default"].showJumpToTopExplanation && /*#__PURE__*/_react["default"].createElement("div", {
          className: _DrupalLecture["default"].jumpToTopExplanation
        }, this.state.allRead || _config["default"].showUpArrowAlwaysAsRead ? (0, _DrupalLectureStrings.getString)('JUMP_ALL_READ') : (0, _DrupalLectureStrings.getString)('JUMP_NOT_ALL_READ'))) : _config["default"].addLecturePadding ? /*#__PURE__*/_react["default"].createElement("div", {
          id: "lecturePadding",
          style: {
            height: '30px'
          }
        }) : null));

        if (!_DeviceInfoHelper["default"].isBrowser() && _config["default"].allowPinchInLecture) {
          return /*#__PURE__*/_react["default"].createElement(_reactZoomPanPinch.TransformWrapper, {
            panningEnabled: !this.state.scrollingEnabled,
            onWheelStart: function onWheelStart() {
              return console.log('onWheelStart');
            },
            onPinching: function onPinching(values) {
              return _this3.setScale(values);
            },
            enableZoomedOutPanning: true,
            minScale: 1,
            defaultScale: 1
          }, /*#__PURE__*/_react["default"].createElement(_reactZoomPanPinch.TransformComponent, null, outerContent));
        }

        return outerContent;
      }
    }
  }]);
  return DrupalLecture;
}(_KESI2BasicComponent["default"]);

exports["default"] = DrupalLecture;
DrupalLecture.propTypes = {
  colorClasses: _propTypes["default"].shape({
    backgroundClass: _propTypes["default"].string,
    glowClass: _propTypes["default"].string
  }).isRequired,
  setTitle: _propTypes["default"].func,
  updateValue: _propTypes["default"].number,
  params: _propTypes["default"].shape({
    contentId: _propTypes["default"].string
  }),
  doNotSetHeight: _propTypes["default"].bool,
  contentPathArray: _propTypes["default"].array,
  setShowFavButton: _propTypes["default"].func,
  setBackButtonFunc: _propTypes["default"].func.isRequired,
  closeTile: _propTypes["default"].func,
  regionCode: _propTypes["default"].string,
  showContent: _propTypes["default"].bool,
  expanded: _propTypes["default"].bool,
  goUpFunc: _propTypes["default"].func,
  scrollFrameId: _propTypes["default"].string,
  currentDayStr: _propTypes["default"].string,
  backgroundColor: _propTypes["default"].string,
  innerBackgroundColor: _propTypes["default"].string,
  goHomeFn: _propTypes["default"].func,
  setWizardArrowFns: _propTypes["default"].func,
  resetScrollIndicatorFn: _propTypes["default"].func
};
DrupalLecture.defaultProps = {
  setTitle: function setTitle() {},
  updateValue: -1,
  params: {
    contentId: null
  },
  doNotSetHeight: false
};